(function installOchayaPreviewCheckoutGuard() {
  'use strict';

  const core = window.OchayaProductV2Core;
  if (!core) return;

  const checkoutBlockedClass = 'ochaya-preview-checkout-blocked';
  const serverMarkerSelector = '[data-ochaya-preview-checkout-state]';
  let observedServerMarkers = [];
  let observedServerValues = [];

  const checkoutSelector = [
    '#checkout',
    '[name="checkout"]',
    'a[href*="/checkout"]',
    '.additional-checkout-buttons button',
    'shopify-accelerated-checkout',
    'shopify-accelerated-checkout-cart',
    'shopify-buy-it-now-button',
  ].join(',');

  function serverState() {
    const markers = [...document.querySelectorAll(serverMarkerSelector)];
    const values = markers.map((marker) => marker.getAttribute('data-ochaya-preview-checkout-state'));
    const changed =
      markers.length !== observedServerMarkers.length ||
      markers.some((marker, index) => marker !== observedServerMarkers[index] || values[index] !== observedServerValues[index]);

    observedServerMarkers = markers;
    observedServerValues = values;

    if (markers.length === 0) return { changed, value: null };
    return { changed, value: values.some((value) => value === 'true') };
  }

  function isActive({ acceptServerState = false } = {}) {
    const renderedState = serverState();
    if (renderedState.value === true || (renderedState.value !== null && (acceptServerState || renderedState.changed))) {
      core.setPreviewOfferSelected(window.sessionStorage, renderedState.value);
      return renderedState.value;
    }
    return core.shouldBlockCheckout({
      previewOfferSelected: core.isPreviewOfferSelected(window.sessionStorage),
    });
  }

  const copy = () => core.copyFor(document.documentElement.lang);

  function showNotice() {
    const renderedNotice = document.querySelector('[data-tray-preview-checkout-note]');
    if (renderedNotice) {
      renderedNotice.hidden = false;
      const fallbackNotice = document.querySelector('[data-ochaya-preview-checkout-guard-notice]');
      if (fallbackNotice) fallbackNotice.hidden = true;
      return;
    }
    let notice = document.querySelector('[data-ochaya-preview-checkout-guard-notice]');
    if (!notice) {
      notice = document.createElement('p');
      notice.dataset.ochayaPreviewCheckoutGuardNotice = '';
      notice.className = 'ochaya-preview-checkout-guard-notice';
      notice.setAttribute('role', 'alert');
      const container =
        document.querySelector('.cart__ctas') ||
        document.querySelector('.cart-drawer__checkout-buttons') ||
        document.querySelector('main') ||
        document.body;
      container.prepend(notice);
    }
    const message = copy().checkoutBlocked;
    if (notice.textContent !== message) notice.textContent = message;
    notice.hidden = false;
  }

  function composedCheckoutControl(event) {
    return event
      .composedPath()
      .find((node) => node instanceof Element && node.matches?.(checkoutSelector));
  }

  function block(event) {
    if (!isActive()) return false;
    event.preventDefault();
    event.stopImmediatePropagation();
    showNotice();
    return true;
  }

  document.addEventListener(
    'click',
    (event) => {
      if (composedCheckoutControl(event)) block(event);
    },
    true,
  );

  document.addEventListener(
    'submit',
    (event) => {
      if (!isActive()) return;
      const submitter = event.submitter;
      const form = event.target;
      const isCheckoutSubmission =
        (submitter instanceof Element && submitter.matches(checkoutSelector)) ||
        (form instanceof HTMLFormElement && /\/cart(?:\?|$)/u.test(form.action) && submitter?.name === 'checkout');
      if (isCheckoutSubmission) block(event);
    },
    true,
  );

  function guardControls({ acceptServerState = false } = {}) {
    if (!isActive({ acceptServerState })) {
      document.body?.classList.remove(checkoutBlockedClass);
      document.querySelectorAll('[data-ochaya-preview-checkout-guarded]').forEach((control) => {
        control.removeAttribute('aria-disabled');
        if (control instanceof HTMLButtonElement || control instanceof HTMLInputElement) {
          control.disabled = control.dataset.ochayaPreviewCheckoutWasDisabled === 'true';
        }
        if (control.localName.startsWith('shopify-')) control.inert = false;
        delete control.dataset.ochayaPreviewCheckoutGuarded;
        delete control.dataset.ochayaPreviewCheckoutWasDisabled;
      });
      const notice = document.querySelector('[data-ochaya-preview-checkout-guard-notice]');
      if (notice) notice.hidden = true;
      return;
    }
    document.body?.classList.add(checkoutBlockedClass);
    document.querySelectorAll(checkoutSelector).forEach((control) => {
      if (control.dataset.ochayaPreviewCheckoutGuarded === undefined) {
        control.dataset.ochayaPreviewCheckoutWasDisabled = String(
          (control instanceof HTMLButtonElement || control instanceof HTMLInputElement) && control.disabled,
        );
      }
      control.setAttribute('aria-disabled', 'true');
      control.dataset.ochayaPreviewCheckoutGuarded = '';
      if (control instanceof HTMLButtonElement || control instanceof HTMLInputElement) control.disabled = true;
      if (control.localName.startsWith('shopify-')) control.inert = true;
    });
    showNotice();
  }

  const start = () => {
    guardControls({ acceptServerState: true });
    new MutationObserver(guardControls).observe(document.body, {
      attributes: true,
      attributeFilter: ['data-ochaya-preview-checkout-state'],
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
